import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Observable, of, BehaviorSubject, Subscription } from "rxjs";
import { tap } from "rxjs/operators";
//import { GridOptions, ColDef } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef } from "ag-grid-community";

import { GridFormatterService } from '../../../../../common/services/grid-formatter.service';
import { FinancialAssuranceService } from '../../../../../common/services/financial-assurance.service';
import { ModalInfoComponent } from "../../../../../common/components/ag-grid/modal-info.component";
import { Dialog } from "../../../../../core/models/dialog.model";
import { StratigraphicWellFinancialAssuranceView, StratigraphicWellFinancialAssuranceRow } from "../../../../../common/models/financialAssurance.model";


@Component({
    selector: 'stratigraphic-wells-no-bonding',
    templateUrl: './stratigraphic-wells-no-bonding.component.html',
    styleUrls: ['./stratigraphic-wells-no-bonding.component.scss'],
    standalone: false
})
export class StratigraphicWellsNoBondingComponent implements OnInit, OnDestroy {

    private _data: StratigraphicWellFinancialAssuranceView[];
    private _data$: BehaviorSubject<StratigraphicWellFinancialAssuranceView[]> = new BehaviorSubject<StratigraphicWellFinancialAssuranceView[]>(null);
    get data(): StratigraphicWellFinancialAssuranceView[] {
        return this._data;
    }

    @Input() gridAriaLabel: string;
    @Input() set data(value: StratigraphicWellFinancialAssuranceView[]) {
        this._data = value;
        this._data$.next(this._data);
    }

    dataObservable$: Observable<StratigraphicWellFinancialAssuranceView[]> = this._data$.asObservable();

    excelStyles: any = this.formatter.excelStyles;

    gridOptions: GridOptions;


    subscription: Subscription = new Subscription();


    constructor(private formatter: GridFormatterService, private financialAssuranceService: FinancialAssuranceService) { }

    ngOnInit() {
        this.gridOptions = this.formatter.BuildDefaultGridOptionsWithColumns(this.buildColumns(), false, true, true, false);
        this.gridOptions.headerHeight = 50;
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    buildColumns(): ColDef[] {
        return [
            {
                cellClass: "stringType",
                headerClass: "wrapped",
                headerName: "API #",
                field: "apiNumber",
                tooltipField: "apiNumber",
                headerTooltip: "API #",
                maxWidth: 115,
                filter: "agTextColumnFilter",
                filterParams: this.formatter.defaultTextFilterParams,
            } as ColDef,
            {
                cellClass: "stringType",
                headerClass: "wrapped",
                headerName: "Company Name",
                field: "companyName",
                tooltipField: "companyName",
                headerTooltip: "Company Name",
                maxWidth: 150,
                filter: "agTextColumnFilter",
                filterParams: this.formatter.defaultTextFilterParams,
            } as ColDef,
            {
                cellClass: "stringType",
                headerClass: "wrapped",
                headerName: "Organization",
                field: "organizationId",
                tooltipField: "organizationId",
                headerTooltip: "Organization",
                maxWidth: 135,
                filter: "agTextColumnFilter",
                filterParams: this.formatter.defaultTextFilterParams,
            } as ColDef,
            {
                cellClass: "stringType",
                headerClass: "wrapped",
                headerName: "RBDMS #",
                field: "rbdmsOwnerNumber",
                tooltipField: "rbdmsOwnerNumber",
                headerTooltip: "RBDMS #",
                maxWidth: 115,
                minWidth: 115,
                filter: "agTextColumnFilter",
                filterParams: this.formatter.defaultTextFilterParams,
            } as ColDef,
            {
                cellClass: "stringType",
                headerClass: "wrapped",
                headerName: "Owner Type",
                field: "ownerType",
                tooltipField: "ownerType",
                headerTooltip: "Owner Type",
                maxWidth: 150,
                filter: "agTextColumnFilter",
                filterParams: this.formatter.defaultTextFilterParams,
            } as ColDef,
            {
                cellClass: "stringType",
                headerClass: "wrapped",
                headerName: "Date Spudded",
                field: "spudDate",
                tooltipValueGetter: this.formatter.formatDate("spudDate", "MM/dd/yyyy", "N/A"),
                valueFormatter: this.formatter.formatDate("spudDate", "MM/dd/yyyy", "N/A"),
                headerTooltip: "Date Spudded",
                filter: "agDateColumnFilter",
                filterParams: this.formatter.defaultDateFilterParams,
                maxWidth: 125,
                minWidth: 125
            } as ColDef,
            {
                cellClass: "stringType",
                headerClass: "wrapped",
                headerName: "Compliance",
                field: "inCompliance",
                headerTooltip: "Compliance",
                tooltipValueGetter: this.formatter.formatBooleanToYesNo("inCompliance"),
                valueGetter: this.formatter.formatBooleanToYesNo("inCompliance"),
                maxWidth: 135,
                minWidth: 130
            } as ColDef
        ] as ColDef[];
    }
}
